import React, { useState, useEffect, useRef } from "react";
import ActionButton from "../inputs/ActionButton";
import HamburgerButton from "../inputs/HamburgerButton";
import { generatePageURI, pagePaths, CDN_URI } from "../../common/utilities";
import { Link } from "react-router-dom";
import ClanEmblem from "./ClanEmblem";
import LocalNav from "./LocalNav";
import { useTheme } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import clsx from "clsx";

import styles from "./PlayerHeader.module.scss";


//I tried making this using mat-ui grid, but I couldn't find out how
//to make grid items bump up aganinst each other the way that
//header items need to in desktop mode according to the design.

export default function PlayerHeader(props) {
  const { data, creator, mainPage, premiumLogged } = props;

  const [navOpen, setNavOpen] = useState(false);

  const localNavMobileNode = useRef();
  const localNavDesktopNode = useRef();
  const hamburgerBtnDesktopNode = useRef();
  const hamburgerBtnMobileNode = useRef();

  const { t } = useTranslation();

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));

  //for dropdown click outside and close - used pointerevent instead
  //of mouseevent because mouse event did not work on pins section
  //that uses indiana scroll component
  // https://medium.com/@pitipatdop/little-neat-trick-to-capture-click-outside-with-react-hook-ba77c37c7e82
  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    document.addEventListener("pointerdown", handleClick, false);

    return () => {
      document.removeEventListener("pointerdown", handleClick);
    };
  }, []);

  //parse API data for use in jsx
  const parsedData = data && {
    ign: data.NICK,
    clanName: data.clanName,
    clanEmblem: {
      markLayer01: data.markLayer01,
      markLayer02: data.markLayer02,
      markLayer03: data.markLayer03,
      markLayer04: data.markLayer04
    },
    rankTitle: data.EXP_TIER_DISPLAY_NAME,
    rankID: data.EXP_TIER_CATEGORY_ID,
    prevRankEXP: data.EXP_TIER_SCORE_INI,
    nextRankEXP: data.EXP_TIER_SCORE_INI_NEXT,
    EXP: data.EXP,
    LEV: data.LEV,
    FAME_GRADE: data.FAME_GRADE,
    bannerURL: data
  };

  const dataLoaded = parsedData != null;

  const {
    ign = "",
    clanName = "",
    clanEmblem = null,
    rankTitle = "",
    rankID = 0,
    LEV = 0,
    FAME_GRADE = 0,
    prevRankEXP = 0,
    nextRankEXP = 0,
    EXP = 0
  } = dataLoaded ? parsedData : {};

  let l_exppercent =
      nextRankEXP === 0 ? "0%" : `${Math.floor(( (EXP - prevRankEXP) / (nextRankEXP - prevRankEXP) ) * 1000) / 10}%`;

  if(EXP > nextRankEXP)
  {
    l_exppercent = '100%';
  } 
 
  const EXPPercent = l_exppercent;
  //const EXPPercent =
  // nextRankEXP === 0 ? "0%" : `${Math.round(( (EXP - prevRankEXP) / (nextRankEXP - prevRankEXP) ) * 100)}%`;
  
  const handleClick = e => {
    if (
      localNavDesktopNode.current.contains(e.target) ||
      localNavMobileNode.current.contains(e.target) ||
      hamburgerBtnDesktopNode.current.contains(e.target) ||
      hamburgerBtnMobileNode.current.contains(e.target)
    ) {
      return false;
    }

    //otuside click
    setNavOpen(false);
  };

  const hideNav = () => {
    setNavOpen(false);
  };

  const handleLocalNavToggle = () => {
    setNavOpen(!navOpen);
  };
  const backToMain = generatePageURI(pagePaths.MAIN);

  const marshalRank = 100;
  const maxFameGrade = 3;
  const marshalTitle = "Marshal";
  const grandMarshalRankImgSuffux = "grandmarshal";

  var displayRankTitle = rankTitle;
  var displayRankLevel = rankID + 1;
  // Grand Marshal Rule to be applied when necessary
  /*
  if (FAME_GRADE) {
    displayRankLevel =
      FAME_GRADE <= maxFameGrade && parseInt(LEV, 10) >= marshalRank
        ? displayRankLevel + parseInt(FAME_GRADE, 10)
        : displayRankLevel;
    //displayRankTitle = marshalTitle + ' ' + FAME_GRADE;
  }

  if( grandmarshal__rules__apply){ 
    displayRankLevel = grandMarshalRankImgSuffux;
  }
  // */

  return (
    <div className={styles.header__container} id="nav_profile_sticky">
      <div
        className={styles.mobile_local_nav_container}
        style={!navOpen ? { display: "none" } : {}}
        ref={localNavMobileNode}
      >
        {/* <div className="divider" style={{ height: 42 }} /> */}
        <div className={styles.content}>
          <LocalNav
            mobile
            mainPage={mainPage}
            creator={creator}
            onAnchorClick={hideNav}
            premiumLogged={premiumLogged}
          />
        </div>
      </div>

      <section className={clsx(styles.mobileprofilebottommenu, mobile && styles.mobile)}>

        {/* premiumLogged && ( the code below after testing )*/}
        {premiumLogged && (
            <div className={clsx(styles.mobileprofilebottomprofile)}>
              <a href={generatePageURI(pagePaths.PROFILE_MANAGER)}>
                <button className={'icon icon-edit'} >
                {t('Edit My Profile')}
                </button>
              </a>
            </div>
          )}
        <div className={clsx(styles.mobileprofilebottomquickmenu)}>
          <button className={'icon icon-hamburger'} onClick={handleLocalNavToggle}>
            {t('Quick Menu')}
          </button>
        </div>
      </section>      

      <div className={styles.header__userbar}>
        <div
          className={clsx(
            styles.header__userbar__container,
            mainPage && styles.main_page
          )}
        >
          <div className={styles.header__userbar__info}>
            <h1 className={styles.ign_heading}>
              <Link to={backToMain}>{ign}</Link>
            </h1>
            {(mainPage && !mobile) && (
              <>
                <h2
                  className={styles.clan_info}
                  style={clanName ? {} : { display: "none" }}
                >
                  <ClanEmblem data={clanEmblem} />
                  <span>{clanName}</span>
                </h2>
                <h2 className={styles.rank_info}>
                  <div className={styles.rank_info_contents}>
                    <img src={`${CDN_URI}imgs/rank_${displayRankLevel}.jpg`} />
                    <div>
                      <span>{displayRankTitle}</span>
                      <span className={styles.exp}>{`${EXP} EXP`}</span>
                    </div>
                  </div>
                </h2>
              </>
            )}
            
          </div>
          {(mainPage && mobile) && (
              <div className={styles.header__userbar__info_data}>
                <div
                  className={styles.clan_info}
                  style={clanName ? {} : { display: "none" }}
                >
                  <ClanEmblem data={clanEmblem} />
                  <span>{clanName}</span>
                </div>
                <div className={styles.rank_info}>
                  <div className={styles.rank_info_contents}>
                    <img src={`${CDN_URI}imgs/rank_${displayRankLevel}.jpg`} />
                    <div>
                      <span>{displayRankTitle}</span>
                      <span className={styles.exp}>{`${EXP} EXP`}</span>
                    </div>
                  </div>
                </div>
              </div>
            )}          
          <div className={styles.header__userbar__actions}>
            <div className={styles.edit_pfl_btn_container}>
              {premiumLogged && (
                <ActionButton
                  linkTo={generatePageURI(pagePaths.PROFILE_MANAGER)}
                >
                  {t('Edit My Profile')}
                </ActionButton>
              )}
            </div>
            <div
              className={styles.hamburger_btn_container}
              ref={hamburgerBtnDesktopNode}
            >
              <HamburgerButton onClick={handleLocalNavToggle} />
              <div
                className={styles.desktop_local_nav}
                style={!navOpen ? { display: "none" } : {}}
                ref={localNavDesktopNode}
              >
                <LocalNav 
                  creator={creator} 
                  premiumLogged={premiumLogged} 
                  onAnchorClick={hideNav}
               />
              </div>
            </div>
          </div>
        </div>
      </div>
      {(mainPage || !mobile) && (
        <>
          <div className={styles.header__expbar}>
            <div
              className={styles.header__expbar_progress}
              style={{ width: EXPPercent }}
            />
          </div>
          <div className={styles.exp_data_container}>
            <div className={styles.exp_data} style={{ width: EXPPercent }}>
              {rankID < marshalRank &&
                `${EXP}/${nextRankEXP} (${EXPPercent})`}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
